import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { usePaymentsChartsContext } from './hooks/usePaymentsChartsContext';

export const PaymentsYearSum = () => {
    const { chartData } = usePaymentsChartsContext();

    const rawData = chartData?.paymentsYear || [];

    const series = [
        {
            name: 'Valor Total',
            data: rawData.map((item) => item.sum_value || 0)
        }
    ];

    return (
        <SimpleBars
            title="Valor Total - Anual"
            horizontal={false}
            subtitles={rawData.map((item) => getYearLabel(item.ano))}
            series={series}
            showDataLabels={false}
        />
    );
};
